// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3BVhY","cell":"ColumnAccessor_cell__3Qi9i","firstCellAccent":"ColumnAccessor_firstCellAccent__YOSpB"};